const actionTypeIdentifier = '615A3EE3-3006-4417-8484-A546EE4BB0EF'; // to generate open ssms run select newid()

export const setLoading = `SET-WIRELESS-PORT-IN-LOADING-${actionTypeIdentifier}`;
export const getOrderRequestForm = `GET-WIRELESS-PORT-IN-ORDER-REQUEST-${actionTypeIdentifier}`;
export const setFormSubmitting = `SET-WIRELESS-PORT-IN-FORM-SUBMITTING-${actionTypeIdentifier}`;

//location form actions
export const setCountryOptions = `SET-WIRELESS-PORT-IN-COUNTRY-OPTIONS-${actionTypeIdentifier}`;
export const setAddressOptions = `SET-WIRELESS-PORT-IN-ADDRESS-OPTIONS-${actionTypeIdentifier}`;
export const setUserLocation = `SET-WIRELESS-PORT-IN-USER-LOCATION-${actionTypeIdentifier}`;
export const setCountryLoading = `SET-COUNTRY-LOADING-${actionTypeIdentifier}`;
export const setAddressLoading = `SET-ADDRESS-LOADING-${actionTypeIdentifier}`;
//subscription form actions
export const setPlanOptions = `SET-WIRELESS-PORT-IN-PLANS-OPTIONS-${actionTypeIdentifier}`;
export const setSimOptions = `SET-WIRELESS-PORT-IN-SIM-OPTIONS-${actionTypeIdentifier}`;
export const setVendorOptions = `SET-WIRELESS-PORT-IN-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const setOrderOptions = `SET-WIRELESS-PORT-IN-ORDER-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceOptions = `SET-WIRELESS-PORT-IN-DEVICE-OPTIONS-${actionTypeIdentifier}`;
export const setDeviceAccessories = `SET-WIRELESS-PORT-IN-DEVICE-ACCESSORIES-${actionTypeIdentifier}`;
export const setVendorDetails = `SET-WIRELESS-PORT-IN-VENDOR-DETAILS-${actionTypeIdentifier}`;
export const setServiceTypeDetails = `SET-WIRELESS-PORT-IN-SERVICE-TYPE-DETAILS-${actionTypeIdentifier}`;
export const setPrimaryPlanDetails = `SET-WIRELESS-PORT-IN-PRIMARY-PLAN-DETAILS-${actionTypeIdentifier}`;
export const getCircuitTypes = `GET-WIRELESS-PORT-IN-CIRCUIT-TYPES-${actionTypeIdentifier}`;
export const getMobileServiceTypes = `GET-WIRELESS-PORT-IN-MOBILE-SERVICE-TYPES-${actionTypeIdentifier}`;
export const getVendors = `GET-WIRELESS-PORT-IN-VENDOR-OPTIONS-${actionTypeIdentifier}`;
export const getPlanComponent = `GET-WIRELESS-PORT-IN-PLAN-COMPONENT-${actionTypeIdentifier}`;
export const setVendorLoading = `SET-VENDOR-LOADING-${actionTypeIdentifier}`;
export const setCircuitTypesLoading = `SET-CIRCUIT-TYPES-LOADING-${actionTypeIdentifier}`;
export const setMobServiceTypeLoading = `SET-MOB-SERVICE-TYPE-LOADING-${actionTypeIdentifier}`;
export const setPlanOptionLoading = `SET-PLAN-OPTION-LOADING-${actionTypeIdentifier}`;
//business form actions
export const setPurposeOfUseOptions = `SET-WIRELESS-PORT-IN-PURPOSE-OF-USE-OPTIONS-${actionTypeIdentifier}`;
export const setBusinessCaseOptions = `SET-WIRELESS-PORT-IN-BUSINESS-CASE-OPTIONS-${actionTypeIdentifier}`;
export const setShowDeviceOptions = `SET-WIRELESS-PORT-IN-SHOW-DEVICE-OPTIONS-${actionTypeIdentifier}`;
export const setShowOtherAddress = `SET-WIRELESS-PORT-IN-SHOW-OTHER-ADDRESS-${actionTypeIdentifier}`;
export const setFormSubmitted = `SET-WIRELESS-PORT-IN-FORM-SUBMITTED-${actionTypeIdentifier}`;
export const setMobileError = `SET-MOBILE-ERROR-${actionTypeIdentifier}`;

export const portInLocationModelA = {
    countryCode: ''
    , country: ''
    , locationId: ''
    , otherDeliveryAddress: ''
    , deliveryAddress: ''
    , otherDeliveryAddressId: 0
}

export const portInSubscriptionModelA = {
    vendorDetailId: 0
    , orderOptionId: 0
    , equipmentCatalogId: 0
    , accessoryDetailsModel: []
    , planId: 0
    //, simTypeId: 0
    , mobileServiceModel: []
    , planDetails: {
        planComponents: []
    }
    , planDetailsModel: []
    , personalMobile: ''
    , currentVendor: ''
    , accountNumber: ''
    , portPinCode: ''
    , currentBillingAddress: ''
    , circuitTypeId: 0
    , equipmentInventoryId: 0
    , phoneCaseAccessory: false
}

export const portInBusinessModelA = {
    purposeOfUseId: 0
    , busJustiCodeDetailId: 0
    , businessJustification: ''
    , additionalInformation: ''
    , termAgreement: false
}